module.exports = __webpack_public_path__ + "img/patent_image8.4c566c1d.png";